import classNames from 'classnames/bind';
import styles from './PaymentHistory.module.css';
import {
  ADDITIONAL_PERSONNEL_AMOUNT,
  AI_LEARNING_TOOL,
  AMOUNT,
  AMOUNT_DIFFERENCE,
  CLASS_MANAGEMENT_ADDITIONAL_PERSONNEL,
  CLASS_MANAGEMENT_PERSONNEL,
  COMPLETE,
  CURRENCY_UNIT,
  HEADCOUNT,
  INSTALLMENTS,
  MEMBERSHIP,
  MEMBERSHIP_AMOUNT,
  MONTHLY_INSTALLMENTS,
  MORE,
  PAYMENT_AMOUNT,
  PAYMENT_DATE,
  PAYMENT_HISTORY,
  PAYMENT_HISTORY_DESC,
  PAYMENT_METHOD,
  RECEIPT,
  SUBSCRIPTION_PERIOD,
} from '../../../constants';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useGetPaymentHistoryQuery } from '../../../services/membership';
import { PaymentHistoryInfo } from '../../../types/membership';
import { formatDate } from '../../../utils/date';

export default function PaymentHistory() {
  const cx = classNames.bind(styles);
  const navigate = useNavigate();

  const { data: historyList, isLoading, refetch } = useGetPaymentHistoryQuery();

  useEffect(() => {
    refetch();
  }, []);

  if (isLoading || !historyList) return null;

  const Row = ({ info }: { info: PaymentHistoryInfo }) => {
    const [isOpenDetails, setIsOpenDetails] = useState(false);
    const {
      paymentDate,
      paymentYn,
      membershipInfo,
      paymentTotalPrice,
      startDate,
      endDate,
      aitoolService,
      capacityStudent,
      capacityStudentExt,
      cardQuota,
      membershipPrice,
      studentServicePrice,
      paymentMethod,
      receiptUrlList,
      paymentType,
    } = info;
    const formatedPaymentDate = formatDate(paymentDate, 4);

    return (
      <div className={cx('items', { active: isOpenDetails })}>
        <span className={cx('sub')}>
          <span>{formatedPaymentDate}</span>
        </span>
        <span className={cx('sub')}>
          <span>{membershipInfo.description}</span>
        </span>
        <span className={cx('sub')}>
          <span>
            {CURRENCY_UNIT}
            {paymentTotalPrice.toLocaleString()}
          </span>
          <button
            type="button"
            className={cx('btn', 'open_list_more', { on: isOpenDetails })}
            onClick={() => setIsOpenDetails(!isOpenDetails)}
          >
            <i className={cx('svg_i')}></i>
            <span className={cx('blind')}>{MORE}</span>
          </button>
        </span>
        {isOpenDetails && (
          <span className={cx('detail')}>
            <span className={cx('btn_wrap')}>
              {paymentType === 1 ? (
                <button
                  type="button"
                  className={cx('btn', 'skyt', 'plan_receipt')}
                  onClick={() => {
                    window.open(receiptUrlList[0], 'receipt', 'popup=yes');
                  }}
                >
                  <span>{RECEIPT}</span>
                </button>
              ) : (
                <>
                  <span>{RECEIPT}</span>
                  {receiptUrlList.map((url, i) => (
                    <button
                      key={url}
                      type="button"
                      className={cx('btn', 'skyt', 'plan_receipt')}
                      onClick={() => {
                        window.open(url, 'receipt', 'popup=yes');
                      }}
                    >
                      <span>{i + 1}</span>
                    </button>
                  ))}
                </>
              )}
            </span>
            <DetailsValue label={PAYMENT_DATE}>
              <span className={cx('cell')}>
                <span>{formatedPaymentDate}</span>
              </span>
            </DetailsValue>
            <DetailsValue label={MEMBERSHIP}>
              <span className={cx('cell')}>
                <span>{membershipInfo.description}</span>
              </span>
            </DetailsValue>
            <DetailsValue label={SUBSCRIPTION_PERIOD}>
              <span className={cx('cell')}>
                <span>{`${formatDate(startDate)} ~  ${formatDate(
                  endDate
                )}`}</span>
              </span>
            </DetailsValue>
            <DetailsValue label={AI_LEARNING_TOOL}>
              <span className={cx('cell')}>
                <span>{aitoolService}</span>
              </span>
            </DetailsValue>
            <DetailsValue label={CLASS_MANAGEMENT_PERSONNEL}>
              <span className={cx('cell')}>
                <span>
                  {capacityStudent} ({HEADCOUNT})
                </span>
              </span>
            </DetailsValue>
            <DetailsValue label={CLASS_MANAGEMENT_ADDITIONAL_PERSONNEL}>
              <span className={cx('cell')}>
                <span>
                  {capacityStudentExt} ({HEADCOUNT})
                </span>
              </span>
            </DetailsValue>
            <DetailsValue label={MONTHLY_INSTALLMENTS}>
              <span className={cx('cell')}>
                <span>{INSTALLMENTS[cardQuota]}</span>
              </span>
            </DetailsValue>
            <DetailsValue label={PAYMENT_AMOUNT}>
              <span className={cx('cell')}>
                <span>
                  {CURRENCY_UNIT}
                  {paymentTotalPrice.toLocaleString()}
                </span>
              </span>
            </DetailsValue>
            <DetailsValue label={MEMBERSHIP_AMOUNT}>
              <span className={cx('cell')}>
                <span>
                  + {CURRENCY_UNIT}
                  {membershipPrice.toLocaleString()}
                </span>
              </span>
            </DetailsValue>
            <DetailsValue label={ADDITIONAL_PERSONNEL_AMOUNT}>
              <span className={cx('cell')}>
                <span>
                  + {CURRENCY_UNIT}
                  {studentServicePrice.toLocaleString()}
                </span>
              </span>
            </DetailsValue>
            <DetailsValue label={PAYMENT_METHOD}>
              <span className={cx('cell')}>
                <span>{paymentMethod}</span>
              </span>
            </DetailsValue>
          </span>
        )}
      </div>
    );
  };

  const DetailsValue = ({ label, children }: any) => {
    return (
      <span
        className={cx('row', {
          color_price:
            label !== PAYMENT_AMOUNT &&
            (label.includes(AMOUNT) || label.includes(AMOUNT_DIFFERENCE)),
        })}
      >
        <span className={cx('cell')}>{label}</span>
        {children}
      </span>
    );
  };

  return (
    <>
      <h2>{PAYMENT_HISTORY}</h2>
      <div className={cx('board_head')}>
        <span>{PAYMENT_DATE}</span>
        <span>{MEMBERSHIP}</span>
        <span>{PAYMENT_AMOUNT}</span>
      </div>
      <div className={cx('board_body')}>
        {historyList.map(
          (info) =>
            !!info.paymentYn && <Row key={info.paymentDate} info={info} />
        )}
      </div>
      <p className={cx('desc')}>※ {PAYMENT_HISTORY_DESC}</p>

      <div className={cx('btn_wrap', 'bottom')}>
        <button
          type="button"
          className={cx('btn', 'b_t', 's48', 'fs18')}
          onClick={() => navigate('../membership')}
        >
          <span>{COMPLETE}</span>
        </button>
      </div>
    </>
  );
}
